import { UserAuth } from '@tools/user/auth';
import { navAnonymousDesktop } from './nav/anonymous/navAnonymousDesktop';
import { navAnonymousMobile } from './nav/anonymous/navAnonymousMobile';
import { navUserDesktop } from './nav/user/navUserDesktop';
import { navUserMobile } from './nav/user/navUserMobile';

const initAnonymousNavigation = () => {
  navAnonymousDesktop();
  navAnonymousMobile();
};

const initUserNavigation = () => {
  navUserDesktop();
  navUserMobile();
};

export const nav = () => {
  if (UserAuth.isLoggedIn()) {
    initUserNavigation();
    return;
  }

  initAnonymousNavigation();
};
